import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, useLocation } from "react-router-dom";
/*image light box*/
import SimpleReactLightbox from "simple-react-lightbox";
/*import wrapping layout*/
// layout default import from compnent
import MainLayout from "./components/layout/Main";
/*import all pages from components*/
import Error from "./components/pages/404/Error";
import About from "./components/pages/about/About";
import EventDetails from "./components/pages/events/eventDetails/EventDetails";
import Events from "./components/pages/events/Events";
/*initialization All css*/
import "./index.css";
import Services from "./components/pages/services/Services";
import ServiceDetails from "./components/pages/services/ServiceDetails";
import Competitions from "./components/pages/competitions/Competitions";
import CompetitionDetails from "./components/pages/competitions/CompetitionDetails";
import PrivacyPolicy from "./components/pages/PrivacyPolicy";
import AppLanding from "./components/pages/AppLanding";
import TermsAndConditions from "./components/pages/TermsAndConditions";

// default Warning Error hide

const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);
  
  return null;
};

const Root = () => {
  const base = process.env.PUBLIC_URL || "/";

  return (
    <BrowserRouter basename={base}>
      <ScrollToTop />
      <Switch>
        <Route exact path="/" component={MainLayout} />
        <Route path="/about" component={About} />
        
        <Route path="/services/:serviceId" component={ServiceDetails} />
        <Route path="/services" component={Services} />

        <Route path="/competitions/:competitionId" component={CompetitionDetails} />
        <Route path="/competitions" component={Competitions} />
        
        <Route path="/events/:eventId" component={EventDetails} />
        <Route path="/events" component={Events} />
        
        <Route path="/privacy-policy" component={PrivacyPolicy} />
        <Route path="/terms" component={TermsAndConditions} />
        <Route path="/app" component={AppLanding} />
        
        <Route path="*" component={Error} />
      </Switch>
    </BrowserRouter>
  );
};

ReactDOM.render(
  <React.StrictMode>
    <SimpleReactLightbox>
      <Root />
    </SimpleReactLightbox>
  </React.StrictMode>,
  document.getElementById("root")
);
